import { Component, Input, Output, ViewChild, EventEmitter, ViewChildren, ElementRef, Renderer2 } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { ProjectDataPerimetro } from 'src/app/entities/project-data-perimetro.entity';
import { ProjectDataPuerta } from 'src/app/entities/project-data-puerta.entity';
import { ProductPickerComponent } from '../product-picker/product-picker.component';
import { DoorPickerComponent } from '../door-picker/door-picker.component';
import { ModelService } from 'src/app/services/model.service';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { BuilderService } from '../../builder.service';
import { Utils } from 'src/app/utils.module';
import { ProjectDataProducto } from 'src/app/entities/project-data-producto.entity';
import { UserListService } from 'src/app/admin/user-list/user-list.service';
import { AlertComponent } from 'src/app/alert/alert.component';
import { templateJitUrl } from '@angular/compiler';


@Component({
	selector: 'app-settingsbox',
	templateUrl: './settingsbox.component.html',
	styleUrls: ['./settingsbox.component.scss']
})
export class SettingsboxComponent {

	@Input() public projectData: ProjectData;
	@Input() public currentPerimeter: ProjectDataPerimetro;
	@Input() public currentDoor: ProjectDataPuerta;
	@Input() public currentViewMode: string;
	@Input() public isDisabled: boolean = false;

	@Output() public onSave: EventEmitter<boolean> = new EventEmitter();
	@Output() public onDeleteDoor: EventEmitter<boolean> = new EventEmitter();
	@Output() public refScreenShot: EventEmitter<boolean> = new EventEmitter();

	@ViewChild('alertWindow') alertWindow: AlertComponent;

	@Input() public canHaveWall: boolean;

	public isMinimized: boolean = false;
	public isProductBoxOpened: boolean = false;
	public currentTab: number = 0;
	public screenshot: string;
	public doorIndex: number;
	public panelIndex : string;
	public alturaPanel: any;
	public arrayPuertas : any = [];

	@ViewChild('productPicker', { static: false }) private productPicker: ProductPickerComponent;
	@ViewChildren('doorPicker') private doorPickers: DoorPickerComponent[];
	public posteSeleccionado: any;
	public topEdgeCut: any;

	constructor(
		public modelService: ModelService,
		private userListService: UserListService,
		private builderService: BuilderService,
		private renderer2: Renderer2
	) {
		const bBtn: boolean = (localStorage.getItem('bBtn') === 'true');
		if (bBtn) { this.isMinimized = bBtn; }
	}

	public refresh() {
		// console.log("ABRE", this.currentPerimeter.producto.tipoPoste )
		if (this.isProductBoxOpened) {
			if (!this.currentPerimeter) return;

			this.currentTab = 0;
			if (!this.currentPerimeter.producto) {
				this.currentPerimeter.producto = new ProjectDataProducto();
			}

			if (this.productPicker) {
				this.productPicker.initialize(this.currentPerimeter.producto);
			}
			if (this.doorPickers) {
				this.doorPickers.forEach((picker) => {
					// el selector de puertas recibe el producto actual para recuperar los tipos puerta asociados
					//this.arrayPuertas.push(picker.data.puerta);
					picker.initialize();
				}, this);
				}

			if (!this.currentPerimeter.producto) {
				this.isProductBoxOpened = true;
				return;
			}

			if (!this.currentPerimeter.producto.familia) return;

			if (this.currentPerimeter.producto.familia.idUnity && this.currentPerimeter.producto.familia.idUnity === 'VERJA') {
				this.isDisabled = false;
			}

		}
	}

	public selectDoor(door: any) {
		const doorLatLng: any = { lat: door.position.lat(), lng: door.position.lng() };
		const doorIndex: number = this.currentPerimeter.puertas.findIndex((item) => {
			return item.lat === doorLatLng.lat && item.lng === doorLatLng.lng;
		});
		this.currentTab = doorIndex + 1; // +1 porque el tab 0 es 'producto panel'
	}

	public handleState(): void {
		this.isMinimized = !this.isMinimized;
		localStorage.setItem('bBtn', this.isMinimized.toString());
	}

	public actualModelo(id: string) {
		let data = this.currentPerimeter.producto
		return (data && data.modelo && data.modelo.idUnity === id);
	}

	private __cacheTitle = '';

	public accionHandleVisibility(action: boolean) {

		if (action === this.isProductBoxOpened) return;
		this.isProductBoxOpened = action;

		// se ha abierto?
		if (this.isProductBoxOpened) {
			Utils.DOM_WebHeader_show(false);
			this.__cacheTitle = this.projectData.nombre;
			this.currentPerimeter.producto.tipoPoste;
			this.refresh();
			this.posteSeleccionado = this.currentPerimeter.producto.tipoPoste;
		} else {
			if (this.projectData.estado === 0) { // Estado borrador SI graba.
				if (!this.projectData.nombre || this.projectData.nombre.trim() === '') {
					this.isProductBoxOpened = true; // No cerrar el configurador.

					const data: AlertData = new AlertData();
					data.title = 'Título incompleto';
					data.message = 'El proyecto debe tener un título.';
					this.alertWindow.show(data);
					//this.model Service.alertSignal.emit(data);
					return;
				}

				// Si es el primer perímtero no dejar salir hasta que configure los básico.
				if (!(this.productPicker.idPanel && this.productPicker.idTipoPanel)|| this.currentPerimeter.producto.tipoPoste =="" || this.currentPerimeter.producto.tipoPoste === "undefined") {
					this.isProductBoxOpened = true; // No cerrar el configurador.
					const data: AlertData = new AlertData();
					data.title = 'Configuración mínima incompleta';
					data.message = 'El perímetro debe tener una familia ,modelo y poste seleccionado.';
					this.alertWindow.show(data);
					//this.modelService.alert Signal.emit(data);
					return;
				}

				if (this.actualModelo('LUX_ELECTRO')) {
					this.currentPerimeter.informacion.alturaMuro = 0;
					this.currentPerimeter.informacion.tieneMuro = false;
					this.currentPerimeter.informacion.tienePlacaBase = false;
				}

				// evento de guardado de datos
				this.onSave.emit(true);
				localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

				// Actualizar el título si es necesario.
				if (this.__cacheTitle !== this.projectData.nombre) {
					Utils.DOMWebHeader_setTitleProject(this.projectData.nombre);
					const _his = this.userListService.historyProjects(
						this.projectData._id,
						this.projectData.nombre,
						this.projectData.renderer,
						this.modelService.getUser().getData())
						.subscribe(() => { _his.unsubscribe(); });
				}

				//if (this.projectData.renderer === Utils.SCHEME2 && this.projectData._id) {
				// Guardar imagen proyecto
				//this.builderService.uploadProjectImage(this.projectData._id, this.screenshot).subscribe(
				//	(result) => { console.log(result); }, (error) => { console.log(error); } );}
				Utils.DOM_WebHeader_show(true);
				// Guardar info proyecto
				this.builderService.saveProject(this.projectData).subscribe(
					(result) => {
						if (this.projectData._id === '' && result._id) this.projectData._id = result._id;
						localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
						const _his = this.userListService.historyProjects(
							this.projectData._id,
							this.projectData.nombre,
							this.projectData.renderer,
							this.modelService.getUser().getData())
							.subscribe(() => { _his.unsubscribe(); });
					},
					(error) => { console.log(error); }
				);
			}
		}
	}

	public CurrentFamily: string = '';
	public OnChangeFamily(family: any): any {
		this.CurrentFamily = family;
	}

	public onSavePerimeter(titulo: any): any {
		this.isProductBoxOpened = false;
		this.projectData.nombre = titulo;
		//this.productPicker.hideColors();
		this.onSave.emit(true);
	}

	public setDoorPanelModel(currentModel): any {
		if (this.doorPickers == null || this.doorPickers == undefined) {
			this.refresh();
		}
		this.doorPickers.forEach((picker) => {
			picker.recuperaModelosPuertas(currentModel)
		}, this);
	}


	public onPosteSeleccionado($event):any{
		this.posteSeleccionado = $event;
	}

	public onTopEdgeCutSeleccionado($event):any{
		this.topEdgeCut = $event;
	}

// <!--  ########### ESPRIVISA-43 ############## -->
	public onAlturaSeleccionada($event){
		//el evento recoge el valor de la medida de la verja seleccionada en el product-picker
		this.alturaPanel = $event;
		//recorremos el array de puertas
		this.doorPickers.forEach((picker)=>{
			console.log(picker)
			//comprobamos en el array si la altura de la puerta es menor que la medida de la verja para resetearse y cambiar la medida de la puerta.
			// en caso de cambiar una de las n puertas, al realizar el for, la puerta será undefined, en caso de que eso pase, se indican con ? para que salte la condición y continue
			if(picker.data?.puerta?.alturaValor < this.alturaPanel){
				picker.clickSeleccionaPuerta();
			}
			},this);

	}

// <!--  ########### ESPRIVISA-43 ############## -->

	public getCurrentProduct(): any {
		return this.currentPerimeter.producto;
	}

	public getCurrentInformation(): any { return this.currentPerimeter; }

	public wallAvailable(): any { return this.currentPerimeter.producto ? this.currentPerimeter.producto.modelo.muro : false; }

	public getCurrentDoor(index: number): any { return this.currentPerimeter.puertas[index]; }

	public removeDoor(index: number): any {
		this.currentPerimeter.puertas.splice(index, 1);
		this.currentTab--;
		this.onSave.emit(true);
		this.onDeleteDoor.emit(true);
	}

	public setCurrentTab(index: number) {
		this.currentTab = (this.currentTab === index) ? 0 : index;
	}

	// private show() { }

	// terrain-info
	public onChangeWall(event: any) {
		this.currentPerimeter.informacion.tieneMuro = event.target.value === 'true' || event.target.value === true;
	}

	public onChangeWallBase(event: any) {
		this.currentPerimeter.informacion.tienePlacaBase = !this.currentPerimeter.informacion.tienePlacaBase;
	}

	public onChangeHeightWall(event: any) {
		// Si no tiene muro ignorar.
		if (!this.currentPerimeter.informacion.tieneMuro) return;
		// Filtrar el número (0-300).
		let value = event.target.valueAsNumber;
		if (value < 0) value = 0; else if (value > 300) value = 300;
		// Asignar el nuevo valor.
		this.currentPerimeter.informacion.alturaMuro = value;
		//value /= 100;
		// Cambiar las elevaciones.
		//for (let e of this.data.informacion.elevaciones) {
		//	if (value + e.elevationValue > 6) e.elevationValue = 6 - value;
		//}
	}

}
